// asgains form submit guard.
// Prevents double-submit on contact + newsletter forms.
// Disables the submit button and adds a spinning state until the response.

(function () {
  'use strict';

  const SELECTORS = [
    'form[action*="/contact"]',
    'form[action*="/customer"]',
    'form[action*="customer_subscribe"]',
    '.newsletter-form',
  ];

  function guard(form) {
    if (form.__asgainsGuarded) return;
    form.__asgainsGuarded = true;

    form.addEventListener('submit', function (e) {
      const submit = form.querySelector(
        'button[type="submit"], input[type="submit"]'
      );
      if (!submit) return;
      // Prevent rapid duplicate submits but allow HTML5 validation to run.
      if (!form.checkValidity || form.checkValidity()) {
        // Mark disabled + visual loading state
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
        submit.dataset.originalLabel = submit.innerHTML;
        submit.innerHTML =
          '<span class="asgains-spinner" aria-hidden="true"></span><span class="visually-hidden">Sending…</span>';
        // Safety net: re-enable after 10s if the page didn't navigate.
        setTimeout(function () {
          if (document.body.contains(submit)) {
            submit.disabled = false;
            submit.removeAttribute('aria-busy');
            if (submit.dataset.originalLabel) {
              submit.innerHTML = submit.dataset.originalLabel;
            }
          }
        }, 10000);
      }
    });
  }

  function init() {
    SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(guard);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
